export default "__VITE_ASSET__DZCRrCez__"